import React, { Component } from "react"

export default class SelectCustom extends Component {
  render() {
    return (
      <div className={this.props.sizeClass}>
        <div className="form-group label-floating">
          <label className="control-label">{this.props.label}</label>
          <select
            disabled={this.props.disabled}
            className="form-control"
            value={this.props.value}
            name={this.props.name}
            onBlur={this.props.onBlur}
            onChange={this.props.onChange}
          >
            {this.props.options.map((value, key) => {
              return (
                <option key={key} value={value.value}>
                  {value.label}
                </option>
              )
            })}
          </select>
          <span className="label label-danger">{this.props.error}</span>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/SelectCustom.js